export const REGISTER_TYPE_PERMISSION = 'PERMISSION/REGISTER_TYPE_PERMISSION';
